<template>
  <b-nav class="nav-toggled">
    <router-link to="/">
      <img
        class="Item toToggle2"
        src="@/assets/PentagroIcon2.png"
        style="cursor: pointer"
        alt="Ícone Pentagro"
      />
    </router-link>
    <b-nav-item-dropdown id="button-start" class="toggled" no-caret :text="$t('start')" left>
      <b-dropdown-item
        class="drop-item"
        v-b-modal.askConfirmActiveOnline
        v-if="user.Permissions.aceitarplanejamento.allowed && user.Permissions.aceitarplanejamento.permission"
      >
        <img
          class="dropItem"
          src="@/assets/aceitarplanejamento.png"
          alt="Planejamento"
        />
        {{ isOnlineRunning == false ? $t("activeOnline") : $t("stopOnline") }}
      </b-dropdown-item>

      <!-- //"Parar On-Line" -->
      <!-- <b-dropdown-divider></b-dropdown-divider> -->

      <b-dropdown-item
        class="drop-item"
        v-b-modal.askConfirmClosingUnit
        v-if="
          user.Permissions.atualizardesempenho.allowed &&
          user.Permissions.atualizardesempenho.permission
        "
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          alt="Atualizar Desempenho"
        />
        {{ $t("atualizardesempenho") }}
      </b-dropdown-item>

      <b-dropdown-item
        class="drop-item"
        @click="switchRotationScreen"
        v-if="hasScreenRotation"
      >
        <img
          class="dropItem"
          src="@/assets/configuracoes.png"
          alt="Planejamento"
        />
        {{
          !rotationScreen
            ? "Ativar Rotação de Telas de Monitoramento"
            : "Desativar Rotação de Telas de Monitoramento"
        }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" v-b-modal.modalGraphTime
        v-if="user.Permissions.configurargraficoocorrencia && user.Permissions.configurargraficoocorrencia.allowed && user.Permissions.configurargraficoocorrencia.permission"
        ><img
          class="dropItem"
          src="@/assets/replannedOrange.png"
          :alt="$t('configurar-periodo-grafico-ocorrencias')"
        />{{user.Permissions.configurargraficoocorrencia.permission}}</b-dropdown-item
      >  

      <b-dropdown-item
        class="drop-item"
        v-b-modal.modalReliabilitySystem
        v-if="
          user.Permissions.configuraraderencia.allowed &&
          user.Permissions.configuraraderencia.permission
        "
      >
        <img
          class="dropItem"
          src="@/assets/configurar.png"
          alt="Configurar comunicação do simulador"
        />{{ $t("configuraraderencia") }}
      </b-dropdown-item>

      <b-dropdown-item
        :disabled = "this.havePermitionMonitoring"
        class= "drop-item"
        v-b-modal.screenrotation
        v-if="
          user.Permissions.configurarrotacaodetelas.allowed &&
          user.Permissions.configurarrotacaodetelas.permission
        "
        :title="user.Permissions.configurarrotacaodetelas.tooltip"
      >
        <img
          class="dropItem"
          src="@/assets/configurar.png"
          :alt="user.Permissions.configurarrotacaodetelas.tooltip"
        />{{ $t("configurarrotacaodetelas") }}
      </b-dropdown-item>

      <b-dropdown-item
        class="drop-item"
        v-b-modal.modalFactorMillingsConfig
        v-if="user.Permissions.configurarfatormoagem.permission && user.Permissions.configurarfatormoagem.allowed"
        :title="user.Permissions.configurarfatormoagem.tooltip"
      >
        <img
          class="dropItem"
          src="@/assets/configurar.png"
          :alt="user.Permissions.configurarfatormoagem.tooltip"
        />{{ $t("configurarfatormoagem") }}
      </b-dropdown-item>



      <b-dropdown-item
        class="drop-item"
        v-b-modal.workShiftClosing
        v-if="
          user.Permissions.fechamentodeturno.allowed &&
          user.Permissions.fechamentodeturno.permission
        "
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          alt="Fechamento de Turno"
        />
        {{ $t("fechamentodeturno") }}
      </b-dropdown-item>

      <b-dropdown-item
        class="drop-item"
        v-b-modal.modalSimulatorConfig
        v-if="
          user.Permissions.configurarsimulador.allowed &&
          user.Permissions.configurarsimulador.permission
        "
      >
        <img
          class="dropItem"
          src="@/assets/configurar.png"
          alt="Configurar comunicação do simulador"
        />{{ $t("configurarsimulador") }}
      </b-dropdown-item>
    </b-nav-item-dropdown>

    <b-modal id="modalScenarioManager" size="xl" hide-footer title="Gestão de cenários" :no-close-on-backdrop="true" :no-close-on-esc="scenarioManagerBusy" :hide-header-close="scenarioManagerBusy" @hidden="onScenarioManagerHidden" header-class="scenario-manager-header" centered>
      <ScenarioManager @scenarioLoaded="onScenarioLoaded" @busy-change="scenarioManagerBusy = $event" :pending-online-activation="pendingOnlineActivation" />
    </b-modal>

    <b-modal
      id="modalFactorMillingsConfig"
      :title="$t('grindingCorrectionFactor')"
      hide-footer
      :no-close-on-backdrop="true"
      size="xl"
    >
      <MillingsConfigsModal></MillingsConfigsModal>
    </b-modal>

    <b-modal size="lg" centered id="modalUpdateScenario" hide-footer :title="$t('updateScenario')">
      <update-scenario></update-scenario>
    </b-modal>

    <b-modal
      id="modalSimulatorConfig"
      hide-footer
      :title="$t('setUpComunication')"
    >
      <simulator-config></simulator-config>
    </b-modal>

    <b-modal
      id="modalReliabilitySystem"
      hide-footer
      :title="$t('setupAdherence')"
    >
      <reliability-system></reliability-system>
    </b-modal>

    <b-modal
      id="screenrotation"
      size="lg"
      hide-footer
      :title="$t('setupScreemRotation')"
    >
      <ScreenRotation></ScreenRotation>
    </b-modal>

    <b-modal
      id="askConfirmClosingUnit"
      size="md"
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        class="msgBox"
        :question="$t('questionConfirmForceClosePerformance')"
        modelname="askConfirmClosingUnit"
        v-bind:action="forcePerformanceIndicatorTreeClosing"
      />
    </b-modal>

    <b-modal
      id="workShiftClosing"
      :title="$t('shiftClosing')"
      size="xl"
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
    >
      <ShiftReportUnified></ShiftReportUnified>
    </b-modal>

    <b-modal
      id="dynamicTankConfiguration"
      title="Dados de Entrada dos Níveis dos Tanques"
      centered
      hide-footer
      :no-close-on-backdrop="true"
    >
      <DynamicTankConfiguration
        @eventCancel="cancelActivation($event)"
      ></DynamicTankConfiguration>
    </b-modal>

    <b-modal
      id="askConfirmActiveOnline"
      size="md"
      centered
      hide-footer
      :title="$t('atention')"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        class="msgBox"
        :question="
          !isOnlineRunning
            ? $t('questionConfirmActivationPlan')
            : $t('questionConfirmDeactivationPlan')
        "
        modelname="askConfirmActiveOnline"
        v-bind:action="switchOnLineMode"
      />
    </b-modal>

    <b-modal id="modalGraphTime" hide-footer :title="$t('configurar-periodo-grafico-ocorrencias')">
      <configurePeriodGraph></configurePeriodGraph>
    </b-modal>

    <b-modal
      id="askConfirmActiveAutonomousMode"
      size="md"
      centered
      hide-footer
      title="Atenção"
      :no-close-on-backdrop="true"
    >
      <MessageBox
        class="msgBox"
        :question="
          autonomousMode == 0
            ? $t('deseja-ativar-o-modo-autonomo')
            : $t('deseja-desativar-o-modo-autonomo')
        "
        modelname="askConfirmActiveAutonomousMode"
        v-bind:action="switchAutonomousMode"
      />
    </b-modal>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, defaultSuccess } from "@/global";
import axios from "axios";
import simulatorConfig from "../simulator/simulatorConfig.vue";
import updateScenario from "../scenario/updateScenario.vue";
import ScenarioManager from "../scenario/ScenarioManager.vue";
import DynamicTankConfiguration from "../dynamicTankConfiguration/DynamicTankConfiguration.vue";
import reliabilitySystem from "../reliabilitySystem/reliabilitySystem";
import ScreenRotation from "../screenRotation/ScreenRotation";
import MessageBox from "./MessageBoxModal.vue";
import ShiftReportUnified from "../workshift/ShiftReportUnified.vue";
import MillingsConfigsModal from "../millingsConfig/modalMillingsFactorConfig.vue"
import configurePeriodGraph from '../occurrence/configurePeriodGraph.vue';


export default {
  name: "IniciarDropdownPGDI",
  data() {
    return {
      hasScreenRotation: false,
      havePermitionMonitoring: true,
      pendingOnlineActivation: false,
      scenarioManagerBusy: false,
    };
  },

  components: {
    simulatorConfig,
    updateScenario,
    ScenarioManager,
    reliabilitySystem,
    MessageBox,
    ShiftReportUnified,
    ScreenRotation,
    DynamicTankConfiguration,
    MillingsConfigsModal,
    configurePeriodGraph
  },
  computed: mapState(["user", "isOnlineRunning", "rotationScreen", "autonomousMode", "scenarioOutdated"]),

  methods: {
    verifyPermission() {
      for (let key in this.user.Permissions){
        if(key.match(/\bmonitoramento\d+\b/) && this.user.Permissions[key].allowed && this.user.Permissions[key].permission != '') this.havePermitionMonitoring = false;
      }
    },

    async loadRotationScreen() {
      let system = this.user.role == "GDI" ? "G" : "P";
      let userUnitId = this.user.UnitId;
      let userId = this.user.Id;

      await axios
        .get(
          `${urlMainAPI}/getscreenrotationsettings/${system}/${userUnitId}/${userId}`
        )
        .then(async (res) => {
          if (res.data) {
            let index = 0;
            res.data.routes.forEach((screen) => {
              if (screen.rotation) index++;
            });
            this.hasScreenRotation = index > 1 ? true : false;
          }
        })
        .catch();
    },

    switchOnLineMode() {
      const url = `${urlMainAPI}/switchonlinemode`;
      if (this.isOnlineRunning) this.$store.commit("setChangingStatus", -1);

      axios
        .post(url)
        .then((res) => {
          if (res.status == 200 && !this.isOnlineRunning) {
            if(res.data != 'On-line ativado com sucesso!'){
              this.pendingOnlineActivation = true;
              this.$bvModal.show("modalScenarioManager");
            }else{
              defaultSuccess(res.data);
              this.$store.commit("setIsOnlineRunning", true);
            }
          } else {
            this.$store.commit("setChangingStatus", 0);
            this.$store.commit("setIsOnlineRunning", false);
            defaultSuccess(this.$t('modo-online-desativado'));
          }
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("setChangingStatus", 0);
        });
    },

    switchAutonomousMode() {
      const url = `${urlMainAPI}/switchautonomousmode`;

      axios
        .post(url)
        .then((res) => {
          if (res.status == 200 && this.autonomousMode == 0)
            defaultSuccess(this.$t('modo-autonomo-ativado-com-sucesso'))
          else
            defaultSuccess(this.$t('modo-autonomo-desativado-com-sucesso'))

          this.$store.commit("setAutonomousMode", this.autonomousMode == 1 ? 0 : 1);
        })
        .catch((err) => {
          this.$store.commit("setAutonomousMode", this.autonomousMode == 1 ? 0 : 1);
          console.error(err);
        });
    },

    onScenarioLoaded() {
      if (this.pendingOnlineActivation) {
        this.pendingOnlineActivation = false;
        this.$bvModal.hide("modalScenarioManager");
        this.$bvModal.show("dynamicTankConfiguration");
      }
    },

    onScenarioManagerHidden() {
      if (this.pendingOnlineActivation) {
        this.pendingOnlineActivation = false;
        this.cancelActivation();
      }
    },

    openDynamyTank(result) {
      if (result) this.$bvModal.show("dynamicTankConfiguration");
      else this.cancelActivation();
    },

    cancelActivation() {
      const url = `${urlMainAPI}/cancelmodelactivation`;
      axios
        .get(url)
        .then((res) => {
          defaultSuccess(res.data);
        })
        .catch();
      this.$store.commit("setChangingStatus", 0);
    },

    switchRotationScreen() {
      let backup = { ...this.rotationScreen };
      this.$store.commit("setRotationScreen", !this.rotationScreen);

      if (backup != this.rotationScreen && this.rotationScreen == true) {
        defaultSuccess(this.$t('rotacao-de-telas-ativado'));
      } else if (
        backup != this.rotationScreen &&
        this.rotationScreen == false
      ) {
        defaultSuccess(this.$t('rotacao-de-telas-desativada'));
      }
    },

    forcePerformanceIndicatorTreeClosing() {
        defaultSuccess(this.$t('iniciado-o-processo-para-recalcular-a-arvore-de-indicadores'));
        const url = `${urlMainAPI}/forceperformanceindicatorclosing`;
        axios
            .get(url)
            .then(res =>{
            defaultSuccess(res.data);
        })
        .catch();
    },
  },

  mounted() {
    this.loadRotationScreen();
  },
  
  created() {
    this.verifyPermission();
  }
};
</script>

<style scoped>
::v-deep .scenario-manager-header {
  background-color: #000;
  color: #fff;
  border-bottom: 3px solid #f60;
}

::v-deep .scenario-manager-header .close {
  color: #fff;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
}


#modalFactorMillingsConfig{
 width: 800px; 
}

.nav-toggled {
  display: flex;
  min-width: 120px;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}
</style>
